export default __webpack_public_path__ + "static/media/rose-card.188cb6c4.png";